const prefix = 'CALENDAR';

export const ADD_EVENTS = Symbol(`${prefix}/ADD_EVENTS`);
export const UPDATE_EVENT = Symbol(`${prefix}/UPDATE_EVENT`);
export const REMOVE_EVENT = Symbol(`${prefix}/REMOVE_EVENT`);
